import { useConfig } from 'hook/config';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DefaultCardTable from 'shared/component/defaultCardTable';
import Layout from 'shared/component/Layout';
import useStyles from './styles';
import { AntTab, AntTabs } from 'shared/component/TabsComponents';
import {
  CircularProgress,
  Icon,
  IconButton,
  Tooltip,
  Typography,
} from '@material-ui/core';
import CardCheckInOut from 'shared/component/cardCheckInOut';
import { icons } from 'asset';
import InputModal from 'shared/component/inputModal';
import ChipFilter from './components/ChipFilter';
import {
  RadioInput,
  RadioInputGroup,
} from 'shared/component/maskedField/checkBox';
import FilterShiftsModal from './components/filterCheckInOut';
import useReport from 'hook/report';
import ModalDetails from './components/modalDetails';
import usePersistedState from 'hook/usePersistedState';
import '../../shared/fixedtab.css';

const CheckInOutContext = React.createContext('CheckInOut');

const CheckInOut = () => {
  const classes = useStyles();
  const { config } = useConfig();
  const { reportsCheck, getCheckInReports, getCheckInPresencePdf } =
    useReport();
  const { data, pagination, loadingCheckReports } = reportsCheck;
  const [searchModal, setSearchModal] = useState(false);
  const [currentTab, setCurrentTab] = usePersistedState(
    'plantaoextra@checkiTab',
    {
      value: 0,
    }
  );
  const [filterModal, setFilterModal] = useState(false);
  const [filterType, setFilterType] = useState('universal');
  const [professionalType, setProfessionalType] = useState('all');
  const [selectedScaleList, setSelectedScaleList] = useState([]);
  const [selectedSituationStatusList, setSelectedSituationStatusList] =
    useState([]);
  const [modal, setModal] = useState({
    openDetails: false,
  });
  const { openDetails } = modal;
  const [reportsFilter, setReportsFilter] = usePersistedState(
    'plantaoextra@checkinDetails',
    {
      page: 1,
      perPage: 12,
      search: '',
      details: '',
      unitId: config.hospitalData.length > 0 ? config.hospitalData[0].id : null,
    }
  );
  const { page, perPage, search, unitId, details } = reportsFilter;

  const localDate = localStorage.getItem('calendarDayPiker');
  const dateObj = new Date();
  const day = moment(dateObj).format('YYYY-MM-DD');
  const [exportingPdf, setExportingPdf] = useState(false);
  const [date, setDate] = React.useState({
    formated_date: localDate ? moment(localDate).format('YYYY-MM-DD') : day,
    date_start: localDate ? moment(localDate).format('YYYY-MM-DD') : day,
    date_end: localDate ? moment(localDate).format('YYYY-MM-DD') : day,
  });
  const handleDateChange = ({ formated_date, date_start, date_end }) => {
    if (date_start && date_end) {
      setDate({
        formated_date: date_start,
        date_start,
        date_end,
      });
      return;
    }
    if (formated_date) {
      setDate({
        formated_date,
        date_start: formated_date,
        date_end: formated_date,
      });
    }
  };
  const selectedArrays = [...selectedScaleList, ...selectedSituationStatusList];

  const onChangeShifts = (e) => {
    setReportsFilter({ ...reportsFilter, search: e, page: 1 });
  };
  const debounce = function (fn, d) {
    let timer;
    return function () {
      let context = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(context, args);
      }, d);
    };
  };
  const debounceForData = debounce(onChangeShifts, 500);
  React.useEffect(() => {
    if (selectedSituationStatusList.length === 0) {
      setFilterType('universal');
    }
  }, [selectedSituationStatusList, data]);

  const handleChangePage = (page) => {
    setReportsFilter({ ...reportsFilter, page });
  };
  const handleChangeTab = (event, newValue) => {
    setCurrentTab({ ...currentTab, value: newValue });
  };
  const openSearchModal = () => {
    setSearchModal(!searchModal);
  };
  const openFilterModal = () => {
    setFilterModal(!filterModal);
  };
  const handleChangeUnit = (unit) => {
    setSelectedSituationStatusList([]);
    setSelectedScaleList([]);
    setReportsFilter({
      ...reportsFilter,
      unitId: unit.id,
      search: '',
      page: 1,
    });
  };

  useEffect(() => {
    if (!unitId) return;
    getCheckInReports({
      page,
      perPage,
      search,
      unitId,
      dateStart: date.date_start || date.formated_date,
      dateEnd: date.date_end || date.formated_date,
      situationStatus: selectedSituationStatusList,
      scaleId: selectedScaleList,
      filter: filterType,
      professionalType,
    });
  }, [
    unitId,
    reportsFilter,
    selectedScaleList,
    selectedSituationStatusList,
    filterType,
    professionalType,
    date,
  ]);

  useEffect(() => {
    const hospitals = config.hospitalData || [];

    if (hospitals.length === 0) {
      setReportsFilter((prev) =>
        prev.unitId == null
          ? prev
          : { ...prev, unitId: null, page: 1, search: '' }
      );
      setSelectedScaleList([]);
      setSelectedSituationStatusList([]);
      return;
    }

    setReportsFilter((prev) => {
      const ids = hospitals.map((h) => h.id);
      if (prev.unitId != null && ids.includes(prev.unitId)) return prev;
      return { ...prev, unitId: hospitals[0].id, page: 1 };
    });
  }, [config.hospitalData]);

  useEffect(() => {
    const hospitals = config.hospitalData || [];
    if (hospitals.length === 0 || unitId == null) return;
    const idx = hospitals.findIndex((h) => h.id === unitId);
    if (idx < 0) return;
    setCurrentTab((prev) =>
      prev.value === idx ? prev : { ...prev, value: idx }
    );
  }, [config.hospitalData, unitId]);

  const abas = config.hospitalData.map((item) => ({
    name: item.name,
    id: item.id,
  }));

  const contextValue = {
    // stateScales: ,
  };
  const removeFilter = (removedFilter, itemLength) => {
    if (itemLength > 3) {
      const newScaleList =
        selectedScaleList.length > 0 &&
        selectedScaleList.filter((scale) => scale.id !== removedFilter);
      setSelectedScaleList(newScaleList);
    } else {
      const newSituationStatusList =
        selectedSituationStatusList.length > 0 &&
        selectedSituationStatusList.filter(
          (situationStatus) => situationStatus.id !== removedFilter
        );
      setSelectedSituationStatusList(newSituationStatusList);
    }
  };
  const handleOpenDetails = (id) => {
    setModal({ ...modal, openDetails: true });
    setReportsFilter({
      ...reportsFilter,
      details: data.find((item) => item.user.id === id),
    });
  };
  const handleCloseDetails = () => {
    setModal({
      ...modal,
      openDetails: false,
    });
  };

  const handleExportPresencePdf = async () => {
    if (!unitId || exportingPdf) return;
    setExportingPdf(true);
    try {
      await getCheckInPresencePdf({
        search,
        unitId,
        dateStart: date.date_start || date.formated_date,
        dateEnd: date.date_end || date.formated_date,
        filter: filterType,
        situationStatus: selectedSituationStatusList,
        scaleId: selectedScaleList,
        professionalType,
      });
    } finally {
      setExportingPdf(false);
    }
  };

  return (
    <Layout
      title="Check-in/Check-out"
      calendarWeek={false}
      calendarDay={false}
      calendarRange
      startToday
      isLoading={loadingCheckReports}
      backArrow
      handleDateChange={handleDateChange}
    >
      <CheckInOutContext.Provider value={contextValue}>
        <div id="fixed-tab">
          <div className={classes.headerCard}>
            <div className={classes.unitsAndFiltersRow}>
              <div className={classes.tabsWrapper}>
                <AntTabs
                  onChange={handleChangeTab}
                  value={currentTab.value}
                  aria-label="ant example"
                >
                  {abas.map((option, i) => (
                    <AntTab
                      key={i}
                      onClick={() => handleChangeUnit(option)}
                      label={option.name}
                    />
                  ))}
                </AntTabs>
              </div>
              <div className={classes.actionsRow}>
                <IconButton
                  onClick={openSearchModal}
                  className={classes.actionButton}
                  title="Buscar profissional"
                >
                  <Icon>search</Icon>
                </IconButton>
                <IconButton
                  onClick={openFilterModal}
                  data-cy="btnFiltroEscalas"
                  className={classes.actionButton}
                  title="Filtrar"
                >
                  <img src={icons.filter} style={{ width: 22 }} alt="Filtrar" />
                </IconButton>
                <Tooltip
                  title="Exportar PDF de presença e permanência"
                  placement="bottom"
                >
                  <span>
                    <IconButton
                      onClick={handleExportPresencePdf}
                      className={classes.actionButton}
                      disabled={!unitId || exportingPdf}
                      data-cy="btnExportarPresencaPdf"
                      title="Exportar PDF"
                    >
                      {exportingPdf ? (
                        <CircularProgress size={18} />
                      ) : (
                        <Icon>picture_as_pdf</Icon>
                      )}
                    </IconButton>
                  </span>
                </Tooltip>
                <RadioInputGroup
                  row
                  name="professionalType"
                  value={professionalType}
                  handleChange={(event) => {
                    setProfessionalType(event.target.value);
                    setReportsFilter({ ...reportsFilter, page: 1 });
                  }}
                  formControlStyle={{ height: 36, marginLeft: 8 }}
                >
                  <RadioInput label="Todos" value="all" />
                  <RadioInput label="Médico" value="doctor" />
                  <RadioInput label="Multi" value="multi" />
                </RadioInputGroup>
                {selectedArrays &&
                  selectedArrays.length > 0 &&
                  selectedArrays.map((filter) => (
                    <ChipFilter
                      key={filter.id}
                      name={filter.name}
                      id={filter.id}
                      itemLength={Object.keys(filter).length}
                      onClick={removeFilter}
                    />
                  ))}
              </div>
            </div>
          </div>
        </div>
        <div className={classes.root}>
          <div>
            <InputModal
              value={search}
              placeholder="Busque por profissionais"
              handleClose={openSearchModal}
              open={searchModal}
              onchange={debounceForData}
            />
            <FilterShiftsModal
              openFilter={filterModal}
              handleClose={openFilterModal}
              filterModal={filterModal}
              setSelectedScaleList={setSelectedScaleList}
              selectedScaleList={selectedScaleList}
              selectedSituationStatusList={selectedSituationStatusList}
              setSelectedSituationStatusList={setSelectedSituationStatusList}
              setFilterModal={setFilterModal}
              setFilterType={setFilterType}
              unitId={unitId}
              dateStart={date}
            />
          </div>
          {!unitId ? (
            <div className={classes.emptyStateCard}>
              <Typography className={classes.emptyStateTitle}>
                Selecione uma unidade hospitalar
              </Typography>
              <Typography className={classes.emptyStateSubtitle}>
                A unidade escolhida na tela inicial deve estar ativa para exibir
                os registros de check-in e check-out.
              </Typography>
            </div>
          ) : (
            <div className={classes.pagination_control} data-cy="divListaCards">
              <DefaultCardTable
                dataList={data}
                renderItem={({ item }) => (
                  <CardCheckInOut
                    item={item}
                    openDetails={handleOpenDetails}
                    id={item.user.id}
                  />
                )}
                loading={false}
                deleteLoading={false}
                totalList={pagination}
                page={page}
                perPage={perPage}
                redirectTo="/inicio"
                showExportButton={false}
                handleChangePage={handleChangePage}
                cellHeight="auto"
                nCols={3}
                spacing={28}
              />
            </div>
          )}
          {openDetails && (
            <ModalDetails
              item={reportsFilter.details}
              unitId={reportsFilter.unitId}
              dateStart={date}
              dateEnd={date}
              openDetails={openDetails}
              details={details}
              handleCloseDetails={handleCloseDetails}
              company={
                config.hospitalData[0] && config?.hospitalData[0]?.company?.name
              }
            />
          )}
        </div>
      </CheckInOutContext.Provider>
    </Layout>
  );
};

export default CheckInOut;
